// landing.js

import p5 from 'p5';
import './style1.css';
import { sketch } from './generative-art.js';

document.addEventListener('DOMContentLoaded', () => {

    const startPrompt = document.getElementById('start-prompt');
    const splashScreen = document.getElementById('splash-screen');
    const textContainer = document.getElementById('text-container');
    const mainContent = document.getElementById('main-content');
    const statementContainer = document.getElementById('statement-container');
    const constellationContainer = document.getElementById('constellation-container');
    const particleContainer = document.getElementById('particle-container');
    const headerLogo = document.querySelector('.header-logo');
    const signinButton = document.querySelector('.signin-button');

    const introWords = ["Welcome", "To", "The", "Future", "of", "Personal", "AI", "Assistants"];
    const introWordTime = 500;
    const statements = [
        "Your potential, amplified.", "Focus on what matters most.", "Clarity in a complex world.", "Your personal AI co-pilot.",
        "The central AI system for your life.", "A unified AI command center.", "Fluid, push-to-talk voice command.",
        "Analyze documents, photos, and video.", "Turn thoughts into structured text.", "Automatically capture action items from your speech.",
        "Your personal AI meeting scribe.", "Get instant meeting summaries and transcripts.", "Place global calls with live transcription.",
        "Receive real-time AI guidance on calls.", "Translate conversations as they happen.", "A to-do list that builds itself.",
        "Let AI prioritize your most important tasks.", "Break down large goals into simple steps.", "Your private AI confidant.",
        "Discover yourself with AI guided journaling.", "Analyse mood and cognitive patterns, privately.", "Chat seamlessly in any language.",
        "A personal CRM that enriches itself.", "Get AI-powered briefings before every meeting.", "Your creative AI partner.",
        "Generate text and images from a single prompt.", "Your live AI sounding board.", "Solve complex problems by thinking out loud.",
        "Rehearse presentations and practice new skills.", "Sculpt your AI to think and write like you.", "Make it yours. Truly yours.",
        "When AI isn't enough, a human is on standby.", "Delegate real-world tasks. Consider them done."
    ];
    const statementDisplayTime = 4000;

    const ghostPositions = [
        { top: '20%', left: '15%' }, { top: '10%', left: '80%' }, { top: '85%', left: '10%' },
        { top: '22%', left: '75%' }, { top: '5%', left: '8%' },   { top: '80%', left: '85%' },
        { top: '48%', left: '5%' },  { top: '45%', left: '90%' }, { top: '93%', left: '65%' },
        // --- THIS LINE WAS ADJUSTED ---
        { top: '55%', left: '10%' }, // Was { top: '42%', left: '20%' } for "Automatically capture..."
        // --- END OF ADJUSTMENT ---
        { top: '15%', left: '50%' }, { top: '70%', left: '8%' },
        { top: '65%', left: '82%' }, { top: '5%', left: '35%' },  { top: '95%', left: '5%' },
        { top: '20%', left: '45%' }, { top: '25%', left: '90%' }, { top: '88%', left: '40%' },
        { top: '62%', left: '15%' }, { top: '55%', left: '85%' }, { top: '35%', left: '8%' },
        { top: '78%', left: '35%' }, { top: '30%', left: '30%' }, { top: '82%', left: '75%' },
        { top: '50%', left: '20%' }, { top: '40%', left: '78%' }, { top: '90%', left: '5%' },
        { top: '70%', left: '93%' }, { top: '33%', left: '55%' }, { top: '95%', left: '85%' },
        { top: '65%', left: '45%' }, { top: '50%', left: '68%' }, { top: '3%', left: '20%' },
        { top: '98%', left: '20%' }, { top: '75%', left: '55%' }
    ];

    let notificationSound;
    let statementIndex = 0;
    let currentLogoScale = 1.0;
    let currentLogoGlow = 2;
    let usedStatements = new Set();

    document.body.addEventListener('click', startSequence, { once: true });

    function startSequence() {
        startPrompt.classList.add('hidden');
        splashScreen.classList.remove('hidden');
        document.body.style.cursor = 'none';
        speak("Welcome, I am Em, the future of personal AI assistants.");
        notificationSound = new Audio('assets/logos/mnotification.mp3');

        let wordIndex = 0;
        const textInterval = setInterval(() => {
            if (wordIndex >= introWords.length) {
                clearInterval(textInterval);
                textContainer.innerHTML = '';
                transitionToMainContent();
                return;
            }
            textContainer.innerHTML = `<span class="word">${introWords[wordIndex]}</span>`;
            wordIndex++;
        }, introWordTime);
    }

    function transitionToMainContent() {
        if (notificationSound) { notificationSound.play().catch(error => console.error(error)); }
        splashScreen.classList.add('is-hiding');
        mainContent.classList.remove('hidden');
        mainContent.classList.add('visible');
        document.body.style.cursor = 'default';
        if (typeof sketch !== 'undefined') { new p5(sketch); }
        setTimeout(() => splashScreen.classList.add('hidden'), 500);
        
        constellationContainer.innerHTML = '';
        statementIndex = 0;
        usedStatements.clear();
        runStatementLoop();
    }

    function runStatementLoop() {
        if (statementIndex >= statements.length) {
            showFinalCTA();
            return;
        }

        const currentStatementText = statements[statementIndex];
        statementContainer.innerHTML = `<span class="statement">${currentStatementText}</span>`;

        setTimeout(() => {
            if (!usedStatements.has(currentStatementText)) {
                createGhostStatement(currentStatementText);
                usedStatements.add(currentStatementText);
            }
            
            animateParticleToLogo();
            updateLogo();

            statementIndex++;
            runStatementLoop();
        }, statementDisplayTime);
    }
    
    function createGhostStatement(text) {
        const ghost = document.createElement('div');
        ghost.className = 'statement-ghost';
        ghost.textContent = text;
        
        const position = ghostPositions[usedStatements.size % ghostPositions.length];
        
        ghost.style.top = position.top;
        ghost.style.left = position.left;
        
        constellationContainer.appendChild(ghost);
    }

    function animateParticleToLogo() {
        const particle = document.createElement('div');
        particle.className = 'charging-particle';
        particleContainer.appendChild(particle);
        particle.addEventListener('animationend', () => particle.remove());
    }

    function updateLogo() {
        currentLogoScale = Math.min(1.5, currentLogoScale + 0.015);
        currentLogoGlow = Math.min(15, currentLogoGlow + 0.5);
        headerLogo.style.transform = `scale(${currentLogoScale})`;
        headerLogo.style.filter = `drop-shadow(0 0 ${currentLogoGlow}px rgba(0, 0, 0, 0.2))`;
    }

    function showFinalCTA() {
        const finalStatement = document.createElement('span');
        finalStatement.className = 'statement statement-final'; 
        finalStatement.textContent = 'Join the AI Future.';
        
        finalStatement.style.animation = 'none';
        statementContainer.innerHTML = '';
        statementContainer.appendChild(finalStatement);
        
        setTimeout(() => {
            finalStatement.style.opacity = 1;
            finalStatement.style.transition = 'opacity 1s ease-in';
        }, 100);

        signinButton.classList.add('pulse-final');
    }

    function speak(text) {
        if ('speechSynthesis' in window) {
            speechSynthesis.cancel();
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.rate = 0.9;
            speechSynthesis.speak(utterance);
        }
    }
});